<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button type="success" size="mini" @click="getDate()">刷新</el-button>
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      >
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px">UID</label>
        <el-input
          v-model="uid"
          placeholder="请输入uid"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">账号 </label>
        <el-input
          v-model="username"
          placeholder="请输入账号"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">VIP等级</label>
        <el-input
          v-model="vipStr"
          placeholder="多个等级#号隔开"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">上级UID</label>
        <el-input
          v-model="parentUid"
          placeholder="请输入上级UID"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">ip</label>
        <el-input
          v-model="ip"
          placeholder="请输入ip"
          style="width: 110px"
          size="mini"
          clearable
        />
      </div>

      <div class="item_warp">
        <label style="margin: 0 10px">地区/国家</label>
        <el-input
          v-model="ipAddress"
          placeholder="请输入地区/国家"
          style="width: 110px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">下级团队 ></label>
        <el-input
          v-model="minChildCount"
          placeholder="请输入下级团队"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">乙方</label>
        <el-input
          v-model="yifangUsername"
          placeholder="请输入乙方"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>

      <div class="item_warp">
        <label style="margin: 0 10px">业务员</label>
        <el-select
          v-model="isYewu"
          style="width: 100px"
          placeholder="请选择"
          clearable
        >
          <el-option label="不限" value=""></el-option>
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">充值用户</label>
        <el-select
          v-model="isRecharge"
          style="width: 100px"
          placeholder="请选择"
          clearable
        >
          <el-option label="不限" value=""></el-option>
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">账号状态</label>
        <el-select
          v-model="isEnabled"
          style="width: 100px"
          placeholder="请选择"
          clearable
        >
          <el-option label="不限" value=""></el-option>
          <el-option label="启用" value="true"></el-option>
          <el-option label="禁用" value="false"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <el-checkbox v-model="isLock">登录锁定</el-checkbox>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">累计奖励 ></label>
        <el-input
          v-model="minTotalAward"
          placeholder="请输入累计奖励"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">老用户</label>
        <el-select
          v-model="platformMemo"
          style="width: 100px"
          placeholder="请选择"
          clearable
        >
          <el-option label="不限" value=""></el-option>
          <el-option label="全部充值" value="allRecharge"></el-option>
          <el-option label="全部" value="all"></el-option>
          <el-option label="MD" value="MD"></el-option>
          <el-option label="BAM" value="BAM"></el-option>
          <el-option label="HR" value="HR"></el-option>
          <el-option label="ADAS" value="ADAS"></el-option>
          <el-option label="HH" value="HH"></el-option>
          <el-option label="EG" value="EG"></el-option>
          <el-option label="XBK" value="XBK"></el-option>
          <el-option label="XPET" value="XPET"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">提现2U</label>
        <el-select
          v-model="isWith"
          style="width: 100px"
          placeholder="请选择"
          clearable
        >
          <el-option label="不限" value=""></el-option>
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">备注</label>
        <el-input
          v-model="memo"
          placeholder="请输入备注"
          style="width: 100px"
          size="mini"
          clearable
        />
      </div>
      <!-- <div class="item_warp">
        <el-checkbox v-model="etw">Dogex可提2U</el-checkbox>
      </div> -->
      <div class="item_warp">
        <label style="margin: 0 10px">注册时间</label>
        <el-date-picker
          v-model="dataTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          style="margin-right: 10px; flex: 1"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
     
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 2451px"
      size="mini"
    >
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <div>
            <div style="margin-bottom: 5px">
              <el-button
                type="primary"
                class="edit-button"
                style="width: 70px"
                size="mini"
                @click="getSetIsEnabled(scope.row)"
                >编辑</el-button
              >
            </div>
            <div style="margin-bottom: 5px">
              <el-button
                type="primary"
                class="edit-button"
                size="mini"
                @click="getChong(scope.row)"
                >手动充值</el-button
              >
            </div>
            <div>
              <el-button
                type="primary"
                class="edit-button"
                size="mini"
                @click="getZiJin(scope.row)"
                >资金明细</el-button
              >
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="UID" width="100">
        <template slot-scope="scope">
          <div>
            <div>
              {{ scope.row.uid }}
            </div>
            <div v-if="scope.row.isYewu" style="color: #ff0000">业务员</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="username" label="账号" width="100" />
      <el-table-column prop="WhatsApp" label="WhatsApp" width="100">
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.whatsAreaCode">
              +{{ scope.row.whatsAreaCode }}
            </div>
            <div>{{ scope.row.whatsPhone }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="memo" label="备注" width="100" />
      <el-table-column prop="totalInvestBuyAmountReal" align="center" width="150">
        <template #header>
          <div class="flex">
            <span class="gbRed">实时投资金额</span>
            <img
              @click="selectOrder('实时投资金额', 'asc')"
              v-if="totalInvestBuyAmountReal == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('实时投资金额', '')"
              v-if="totalInvestBuyAmountReal == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('实时投资金额', 'desc')"
              v-if="totalInvestBuyAmountReal == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="teamLevelStr" align="center" width="150">
        <template #header>
          <div class="flex">
            <span class="gbRed">团队等级</span>
            <img
              @click="selectOrder('团队等级', 'asc')"
              v-if="teamLevelStr == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('团队等级', '')"
              v-if="teamLevelStr == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('团队等级', 'desc')"
              v-if="teamLevelStr == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalInvestBuyAmount" align="center" width="110">
        <template #header>
          <div class="flex">
            <span class="gbRed">累计投资金额</span>
            <img
              @click="selectOrder('累计投资金额', 'asc')"
              v-if="totalInvestBuyAmount == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计投资金额', '')"
              v-if="totalInvestBuyAmount == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计投资金额', 'desc')"
              v-if="totalInvestBuyAmount == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="amount" align="center" width="110">
        <template #header>
          <div class="flex">
            <span class="gbRed">USDT余额</span>
            <img
              @click="selectOrder('余额', 'asc')"
              v-if="amountOrder == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('余额', '')"
              v-if="amountOrder == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('余额', 'desc')"
              v-if="amountOrder == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
        <el-table-column prop="totalEarn" label="累计收入USDT" width="150">
        <template #header>
          <div class="flex">
            <span class="gbRed">累计收入USDT</span>
            <img
              @click="selectOrder('累计收入USDT', 'asc')"
              v-if="totalEarn == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计收入USDT', '')"
              v-if="totalEarn == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计收入USDT', 'desc')"
              v-if="totalEarn == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecharge" label="" width="100">
        <template #header>
          <div class="flex">
            <span class="gbRed">累计充值USDT</span>
            <img
              @click="selectOrder('累计充值', 'asc')"
              v-if="totalRecharge == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值', '')"
              v-if="totalRecharge == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值', 'desc')"
              v-if="totalRecharge == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalWithdraw" label="" width="100">
        <template #header>
          <div class="flex">
            <span class="gbRed">累计提现USDT</span>
            <img
              @click="selectOrder('累计提现', 'asc')"
              v-if="totalRechargeOrder == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计提现', '')"
              v-if="totalRechargeOrder == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计提现', 'desc')"
              v-if="totalRechargeOrder == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="parentUid" label="上级" width="100" />
      <el-table-column prop="address" label="下级总数" width="100">
        <template #header>
          <div class="flex">
            <span class="gbRed">下级总数</span>
            <img
              @click="selectOrder('下级总数', 'asc')"
              v-if="childrenCount == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('下级总数', '')"
              v-if="childrenCount == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('下级总数', 'desc')"
              v-if="childrenCount == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
        <template slot-scope="scope">
          <div>
            {{ scope.row.childrenCount }}
            <div>
              <el-button
                type="primary"
                class="edit-button"
                size="mini"
                @click="getChildrenSum(scope.row)"
                >详情</el-button
              >
              <!-- <el-button
                type="primary"
                class="edit-button"
                size="mini"
                @click="toTree(scope.row)"
                >下级树</el-button
              > -->
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="teamAmount" label="USDT团队余额" width="100">
        <template #header>
          <div class="flex">
            <span class="gbRed">团队余额</span>
            <img
              @click="selectOrder('团队余额', 'asc')"
              v-if="teamAmount == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('团队余额', '')"
              v-if="teamAmount == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('团队余额', 'desc')"
              v-if="teamAmount == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalTeamEarn" label="团队累计收入" width="150">
        <template #header>
          <div class="flex">
            <span class="gbRed">团队累计收入</span>
            <img
              @click="selectOrder('团队累计收入', 'asc')"
              v-if="totalTeamEarn == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('团队累计收入', '')"
              v-if="totalTeamEarn == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('团队累计收入', 'desc')"
              v-if="totalTeamEarn == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="amountTrx" label="TRX余额" width="100">
        <template #header>
          <div class="flex">
            <span class="gbRed">TRX余额</span>
            <img
              @click="selectOrder('TRX余额', 'asc')"
              v-if="amountTrxOrder == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('TRX余额', '')"
              v-if="amountTrxOrder == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('TRX余额', 'desc')"
              v-if="amountTrxOrder == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="amountBtc" label="BTC余额" width="100" />
      <el-table-column prop="amountEth" label="ETH余额" width="100" />
      <el-table-column prop="amountBnb" label="BNB余额" width="100" />
      <el-table-column prop="amountUsdc" label="USDC余额" width="100" />
      <el-table-column prop="amountPol" label="POL余额" width="100" />
      <el-table-column prop="amountDai" label="DAI余额" width="100" />
      <el-table-column prop="amountDoge" label="DOGE余额" width="100" />
      <el-table-column prop="totalEscapeBuyAmount" label="" width="130">
        <template #header>
          <div class="flex">
            <div class="gbRed">
              <div>BitZooAB</div>
              <div>投入金额</div>
            </div>
            <img
              @click="selectOrder('投入金额', 'asc')"
              v-if="totalEscapeBuyAmount == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('投入金额', '')"
              v-if="totalEscapeBuyAmount == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('投入金额', 'desc')"
              v-if="totalEscapeBuyAmount == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalEscapeWinAmount" label="" width="130">
        <template #header>
          <div class="flex">
            <div class="gbRed">
              <div>BitZooAB</div>
              <div>躲避金额</div>
            </div>
            <img
              @click="selectOrder('躲避金额', 'asc')"
              v-if="totalEscapeWinAmount == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('躲避金额', '')"
              v-if="totalEscapeWinAmount == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('躲避金额', 'desc')"
              v-if="totalEscapeWinAmount == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalEscapeFailAmount" label="" width="130">
        <template #header>
          <div class="flex">
            <div class="gbRed">
              <div>BitZooAB</div>
              <div>划分金额</div>
            </div>
            <img
              @click="selectOrder('划分金额', 'asc')"
              v-if="totalEscapeFailAmount == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('划分金额', '')"
              v-if="totalEscapeFailAmount == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('划分金额', 'desc')"
              v-if="totalEscapeFailAmount == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalEscapeReturnAmount" label="" width="130">
        <template #header>
          <div class="flex">
            <div class="gbRed">
              <div>BitZooAB</div>
              <div>退还金额</div>
            </div>
            <img
              @click="selectOrder('退还金额', 'asc')"
              v-if="totalEscapeReturnAmount == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('退还金额', '')"
              v-if="totalEscapeReturnAmount == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('退还金额', 'desc')"
              v-if="totalEscapeReturnAmount == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalEscapePreAmount" label="" width="130">
        <template #header>
          <div class="flex">
            <div class="gbRed">
              <div>BitZooAB</div>
              <div>奖励金额</div>
            </div>
            <img
              @click="selectOrder('奖励金额', 'asc')"
              v-if="totalEscapePreAmount == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('奖励金额', '')"
              v-if="totalEscapePreAmount == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('奖励金额', 'desc')"
              v-if="totalEscapePreAmount == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="totalRechargeTrx" label="" width="130">
        <template #header>
          <div class="flex">
            <span class="gbRed">累计充值TRX</span>
            <img
              @click="selectOrder('累计充值TRX', 'asc')"
              v-if="totalRechargeTrx == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值TRX', '')"
              v-if="totalRechargeTrx == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值TRX', 'desc')"
              v-if="totalRechargeTrx == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="totalRechargeBtc" label="" width="130">
        <template #header>
          <div class="flex">
            <span class="gbRed">累计充值BTC</span>
            <img
              @click="selectOrder('累计充值BTC', 'asc')"
              v-if="totalRechargeBtc == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值BTC', '')"
              v-if="totalRechargeBtc == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值BTC', 'desc')"
              v-if="totalRechargeBtc == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRechargeEth" label="" width="130">
        <template #header>
          <div class="flex">
            <span class="gbRed">累计充值ETH</span>
            <img
              @click="selectOrder('累计充值ETH', 'asc')"
              v-if="totalRechargeEth == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值ETH', '')"
              v-if="totalRechargeEth == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值ETH', 'desc')"
              v-if="totalRechargeEth == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRechargeBnb" label="" width="130">
        <template #header>
          <div class="flex">
            <span class="gbRed">累计充值BNB</span>
            <img
              @click="selectOrder('累计充值BNB', 'asc')"
              v-if="totalRechargeBnb == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值BNB', '')"
              v-if="totalRechargeBnb == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值BNB', 'desc')"
              v-if="totalRechargeBnb == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRechargeUsdc" label="" width="140">
        <template #header>
          <div class="flex">
            <span class="gbRed">累计充值USDC</span>
            <img
              @click="selectOrder('累计充值USDC', 'asc')"
              v-if="totalRechargeUsdc == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值USDC', '')"
              v-if="totalRechargeUsdc == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值USDC', 'desc')"
              v-if="totalRechargeUsdc == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRechargeDoge" label="" width="140">
        <template #header>
          <div class="flex">
            <span class="gbRed">累计充值DOGE</span>
            <img
              @click="selectOrder('累计充值DOGE', 'asc')"
              v-if="totalRechargeDoge == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值DOGE', '')"
              v-if="totalRechargeDoge == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计充值DOGE', 'desc')"
              v-if="totalRechargeDoge == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="backendRecharge"
        label="累计充值USDT(后台)"
        width="140"
      >
        <template #header>
          <div class="flex">
            <span class="gbRed">累计充值USDT(后台)</span>
            <img
              @click="selectOrder('累计后台充值', 'asc')"
              v-if="backendRecharge == 'desc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_desc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计后台充值', '')"
              v-if="backendRecharge == 'asc'"
              style="width: 20px; cursor: pointer"
              src="@/img/order_asc.png"
              alt=""
            />
            <img
              @click="selectOrder('累计后台充值', 'desc')"
              v-if="backendRecharge == ''"
              style="width: 20px; cursor: pointer"
              src="@/img/order_no.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="totalWithdrawTrx" label="" width="130">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计提现TRX</span>
              <img @click="selectOrder('累计提现TRX','asc')" v-if="totalWithdrawTrx == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累计提现TRX','')" v-if="totalWithdrawTrx == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累计提现TRX','desc')" v-if="totalWithdrawTrx == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column> -->

      <!-- <el-table-column prop="backendRecharge" label="累计后台充值" width="160">
        <template #header>
            <div class="flex">
              <span class="gbRed">累计后台充值TRX</span>
              <img @click="selectOrder('累计后台充值TRX','asc')" v-if="backendRechargeTrx == 'desc'" style="width:20px;cursor: pointer" src="@/img/order_desc.png" alt="">
              <img @click="selectOrder('累计后台充值TRX','')" v-if="backendRechargeTrx == 'asc'" style="width:20px;cursor: pointer" src="@/img/order_asc.png" alt="">
              <img @click="selectOrder('累计后台充值TRX','desc')" v-if="backendRechargeTrx == ''" style="width:20px;cursor: pointer" src="@/img/order_no.png" alt="">
            </div> 
          </template>
      </el-table-column> -->

      <!-- <el-table-column prop="totalTeamWithdraw" label="累计团队提现" width="110" />
      <el-table-column prop="totalInvestBuyAmount" label="累计购买金额" width="110" />
      <el-table-column prop="totalInvestBuyAmountTrx" label="累计购买TRX" width="110"/>
      <el-table-column prop="totalInvestAward" label="累计投资收益" width="110"/> -->
      <!-- <el-table-column prop="totalAward" label="累计奖励" width="100" /> -->
      <el-table-column prop="address" label="账号状态" width="100">
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.isEnabled" style="color: #06cc00">正常</div>
            <div v-if="!scope.row.isEnabled" style="color: #ff0000">封禁</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="最后登录IP" width="200">
        <template slot-scope="scope">
          <div>
            <div>{{ scope.row.lastIp }}</div>
            <div>{{ scope.row.lastIpAddress }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="telegram" label="Telegram" width="120" />
      <el-table-column prop="platformMemo" label="老用户" width="100" />
      <el-table-column prop="lang" label="语言" width="100" />
      <el-table-column prop="yifangUsername" label="乙方" width="100" />
      <el-table-column prop="ziUid" label="携带子账号" width="100" />
      <el-table-column prop="createDate" label="创建时间" width="170" />
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />
    <!-- 编辑 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="500px"
      title="编辑"
      :center="true"
      :close-on-click-modal="false"
    >
      <!-- 编辑用户表格 -->
      <el-form ref="editForm" :model="active" label-width="120px">
        <el-form-item label="账号状态">
          <el-switch
            v-model="activeIsEnabled"
            active-text="启用"
            inactive-text="封禁"
            @change="setIsEnabledShow = true"
          ></el-switch>
        </el-form-item>
        <el-form-item label="是否是业务员">
          <el-switch
            v-model="active.isYewu"
            active-text="是"
            inactive-text="否"
            @change="setIsYewu"
          ></el-switch>
        </el-form-item>
        <!-- <el-form-item label="2U提现">
          <el-switch
            v-model="isWith2"
            active-text="是"
            inactive-text="否"
            @change="setIsWith"
          ></el-switch>
        </el-form-item> -->
        <el-form-item label="当前团队等级">
          <span>{{active.teamLevelStr}}</span>
        </el-form-item>
        <el-form-item label="锁定团队等级">
          <el-input v-model="active.totalInvestBuyAmountRealLock" placeholder="" />
          <el-button
            style="margin-left: 10px"
            type="primary"
            class="edit-button"
            @click="updateTeamLevelLock()"
            >更新</el-button
          >
        </el-form-item>
        <el-form-item label="">
          <div>
            <div style="line-height: 1;">输入锁定投资金额，系统自动锁定该投资金额对应的团队等级区间，例如</div>
            <div style="line-height: 1;">输入10，则自动锁定Lv0</div>
            <div style="line-height: 1;">输入50，则自动锁定Lv1</div>
            <div style="line-height: 1;">输入100，则自动锁定Lv2</div>
            <div style="line-height: 1;">输入150，则自动锁定Lv3-7</div>
            <div style="line-height: 1;">输入400，则自动锁定Lv8-10</div>
            <div style="line-height: 1;">输入550，则自动锁定Lv11-21</div>
            <div style="line-height: 1;">输入金额0表示不锁定</div>
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="active.memo" placeholder="" />
          <el-button
            style="margin-left: 10px"
            type="primary"
            class="edit-button"
            @click="updateMemo()"
            >更新</el-button
          >
        </el-form-item>
        <el-form-item label="登录密码">
          <el-input v-model="password" placeholder="" />
          <el-button
            style="margin-left: 10px"
            type="primary"
            class="edit-button"
            @click="updatePassword()"
            >更新</el-button
          >
        </el-form-item>
        <el-form-item label="提现密码">
          <el-input v-model="withdrawPassword" placeholder="" />
          <el-button
            style="margin-left: 10px"
            type="primary"
            class="edit-button"
            @click="updateWithdrawPassword()"
            >更新</el-button
          >
        </el-form-item>
        <el-form-item label="登录解锁时间">
          <!-- <el-input v-model="active.lockDate" placeholder=""/> -->
          <el-date-picker
            v-model="lockDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          >
          </el-date-picker>
          <el-button
            style="margin-left: 10px"
            type="primary"
            class="edit-button"
            @click="updateLockDate()"
            >更新</el-button
          >
        </el-form-item>
        <!-- <el-form-item label="免邮箱验证" prop="count">
          
        </el-form-item> -->
        <el-form-item label="" style="margin-bottom: 2px" prop="count">
          <div>免邮箱验证提现地址</div>
        </el-form-item>
        <el-form-item label="" style="margin-bottom: 5px" prop="count">
          <el-input v-model="address.address1" placeholder="" />
        </el-form-item>
        <el-form-item label="" style="margin-bottom: 5px" prop="count">
          <el-input v-model="address.address2" placeholder="" />
        </el-form-item>
        <el-form-item label="" style="margin-bottom: 10px" prop="count">
          <el-input v-model="address.address3" placeholder="" />
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定更新？" @confirm="updateSafeAddress()">
            <el-button slot="reference" type="primary" class="edit-button"
              >更新地址</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="500px"
      title="手动充值"
      :center="true"
      :close-on-click-modal="false"
    >
      <!-- 编辑用户表格 -->
      <el-form ref="editForm" :model="active" label-width="120px">
        <el-form-item label="用户UID：">
          {{ active.uid }}
        </el-form-item>
        <el-form-item label="充值金额">
          <el-input v-model="amount" placeholder="" />
        </el-form-item>
        <el-form-item label="充值密码">
          <el-input v-model="password" placeholder="" />
        </el-form-item>
         <el-form-item label="设置">
          <el-checkbox v-model="isValidRecharge">是否用于有效充值用户</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定充值？" @confirm="chong()">
            <el-button slot="reference" type="primary" class="edit-button"
              >确定</el-button
            >
          </el-popconfirm>
        </el-form-item>
        <!-- <el-form-item label="充值TRX">
          <el-input v-model="amountTRX" placeholder=""/>
        </el-form-item>
        <el-form-item label="充值密码">
          <el-input v-model="passwordTRX" placeholder=""/>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定充值？" @confirm="chongTrx()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >确定</el-button>
        </el-popconfirm>
        </el-form-item> -->
      </el-form>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :visible.sync="setIsYewuShow"
      width="500px"
      title="验证密码"
      :center="true"
      :close-on-click-modal="false"
    >
      <!-- 编辑用户表格 -->
      <el-form ref="editForm" :model="active" label-width="120px">
        <el-form-item label="">
          <el-input v-model="setIsYewuPassword" placeholder="" />
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定修改？" @confirm="getSetIsYewu()">
            <el-button slot="reference" type="primary" class="edit-button"
              >确定</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 密码验证 -->
    <el-dialog
      :visible.sync="setIsEnabledShow"
      width="500px"
      title="请输入密码验证"
      :center="true"
      :close-on-click-modal="false"
      @close="closeIsEnabled()"
    >
      <!-- 编辑用户表格 -->
      <el-form ref="editForm" :model="active" label-width="120px">
        <el-form-item label="">
          <el-input v-model="setIsEnabledPassword" placeholder="请输入密码验证" />
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定修改？" @confirm="setIsEnabled()">
            <el-button slot="reference" type="primary" class="edit-button"
              >确定</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 资金明细 -->
    <el-dialog
      :visible.sync="dialogVisible1"
      width="1100px"
      title="资金明细"
      :center="true"
      :close-on-click-modal="false"
    >
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="amountList"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 940px"
        size="mini"
      >
        <el-table-column prop="sn" label="流水号" width="200" />
        <!-- <el-table-column prop="typeStr" label="类型" width="100" /> -->
        <el-table-column prop="subjectStr" label="抬头" width="170" />
        <el-table-column prop="amount" label="USDT金额" width="100" />
        <el-table-column prop="amountTrx" label="TRX金额" width="100" />
        <el-table-column prop="proportion" label="收益比例" width="100" />
        <el-table-column prop="memo" label="备注" width="100" />
        <el-table-column prop="createDate" label="创建时间" width="170" />
      </el-table>
      <pagination
        :total="total1"
        :page.sync="pageNum1"
        :limit.sync="pageSize1"
        @pagination="getChonList"
      />
    </el-dialog>
    <!-- 下级团队 -->
    <el-dialog
      :visible.sync="dialogVisible2"
      width="960px"
      title="下级团队"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="font-size: 16px; font-weight: 900">所有下级统计：</div>
      <el-table
          :data="[1]"
          tooltip-effect="dark"
          :stripe="true"
          :border="true"
          style="width: 791px;margin: 10px 0;font-size: 14px;"
          size="mini"
        >
          <el-table-column prop="uid" label="注册" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.totalRegister }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="username" label="投资10u以上数量" width="150">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.invest10Count }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="vipLevel" label="Lv1以上数量" width="140">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.lv1Count }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="amount" label="充值USDT" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.totalRecharge }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="totalEarn" label="提现USDT" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.totalWithdraw }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="childrenCount" label="投资人数" width="100">
          <template slot-scope="scope">
              <div>{{ allChildrenSum.investCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="createDate" label="投资USDT" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.investAmount }}</div>
             </template>
          </el-table-column>
      </el-table>
      <div style="font-size: 16px; font-weight: 900">今日数据：</div>
      <el-table
          :data="[1]"
          tooltip-effect="dark"
          :stripe="true"
          :border="true"
          style="width: 501px;margin: 10px 0;font-size: 14px;"
          size="mini"
        >
          <el-table-column prop="uid" label="注册" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.todayRegisterCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="username" label="充值人数" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.todayRechargeCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="vipLevel" label="提现人数" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.todayWithdrawCount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="amount" label="充值金额" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.todayRechargeAmount }}</div>
             </template>
          </el-table-column>
          <el-table-column prop="totalEarn" label="提现金额" width="100">
            <template slot-scope="scope">
              <div>{{ allChildrenSum.todayWithdrawAmount }}</div>
             </template>
          </el-table-column>
      </el-table>
      <el-tabs v-model="level" @tab-click="handleClick">
        <el-tab-pane label="Lv1" name="1"></el-tab-pane>
        <el-tab-pane label="Lv2" name="2"></el-tab-pane>
        <el-tab-pane label="Lv3~7" name="3"></el-tab-pane>
        <el-tab-pane label="Lv8~10" name="4"></el-tab-pane>
        <el-tab-pane label="Lv11~21" name="5"></el-tab-pane>
      </el-tabs>
      <div class="head_search" style="color: rgb(0, 0, 255); font-weight: 500">
        <div class="item_warp" style="margin-right: 20px">
          <div style="margin-right: 10px">注册:</div>
          <div>{{ childrenSum3.totalRegister }}</div>
        </div>
        <div class="item_warp" style="margin-right: 20px">
          <div style="margin-right: 10px">投资10u以上数量:</div>
          <div>{{ childrenSum3.invest10Count }}</div>
        </div>
        <div class="item_warp" style="margin-right: 20px">
          <div style="margin: 0 10px">Lv1以上数量:</div>
          <div>{{ childrenSum3.lv1Count }}</div>
        </div>
        <div class="item_warp" style="margin-right: 20px">
          <div style="margin: 0 10px">充值USDT:</div>
          <div>{{ childrenSum3.totalRecharge }}</div>
        </div>
        <div class="item_warp" style="margin-right: 20px">
          <div style="margin: 0 10px">提现USDT:</div>
          <div>{{ childrenSum3.totalWithdraw }}</div>
        </div>
        <div class="item_warp" style="margin-right: 20px">
          <div style="margin: 0 10px">投资人数:</div>
          <div>{{ childrenSum3.investCount }}</div>
        </div>
        <div class="item_warp" style="margin-right: 20px">
          <div style="margin: 0 10px">投资USDT:</div>
          <div>{{ childrenSum3.investAmount }}</div>
        </div>
      </div>
      <div class="head_search" style="color: rgb(0, 0, 255); font-weight: 500">
        <div class="item_warp" style="margin-right: 10px;color:#000;">
          今日数据
        </div>
        <div class="item_warp" style="margin-right: 10px">
          <div style="margin-right: 10px">注册:</div>
          <div>{{ childrenSum3.todayRegisterCount }}</div>
        </div>
        <div class="item_warp" style="margin-right: 10px">
          <div style="margin: 0 10px">充值人数:</div>
          <div>{{ childrenSum3.todayRechargeCount }}</div>
        </div>
        <div class="item_warp" style="margin-right: 10px">
          <div style="margin: 0 10px">提现人数:</div>
          <div>{{ childrenSum3.todayWithdrawCount }}</div>
        </div>
        <div class="item_warp" style="margin-right: 10px">
          <div style="margin: 0 10px">充值金额:</div>
          <div>{{ childrenSum3.todayRechargeAmount }}</div>
        </div>
        <div class="item_warp" style="margin-right: 10px">
          <div style="margin: 0 10px">提现金额:</div>
          <div>{{ childrenSum3.todayWithdrawAmount }}</div>
        </div>
      </div>

      <div style="margin-top: 25px">
        <el-table
          ref="gridTable"
          v-loading="loading1"
          :data="childrenSum2"
          tooltip-effect="dark"
          :stripe="true"
          :border="true"
          height="540px"
          style="width: 900px"
          size="mini"
        >
          <el-table-column prop="uid" label="UID" width="100" />
          <el-table-column prop="username" label="账号" width="100" />
          <el-table-column prop="amount" label="余额USDT" width="100" />
          <el-table-column prop="totalEarn" label="累计收益" width="100" />
          <el-table-column prop="totalRecharge" label="累计充值USDT" width="130" />
          <el-table-column prop="totalWithdraw" label="累计提现USDT" width="130" />
          <el-table-column prop="childrenCount" label="1级团队数量" width="100" />
          <el-table-column prop="createDate" label="创建时间" width="170" />
        </el-table>
        <pagination
          :total="total2"
          :page.sync="pageNum2"
          :limit.sync="pageSize2"
          @pagination="getChildrenSumList"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination, VueUeditorWrap },
  data() {
    return {
      tableData: [], // 展示的表单信息
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      total1: 0, // 总数
      pageNum1: 1, // 页码值
      pageSize1: 20, // 页大小
      total2: 0, // 总数
      pageNum2: 1, // 页码值
      pageSize2: 20, // 页大小
      loading: false, // 表格加
      loading1: false, // 表格加
      uid: "",
      ip: "",
      yifangUsername: "",
      dataTime: ["", ""],
      username: "",
      vipStr: "",
      parentUid: "",
      ipAddress: "",
      minChildCount: "",
      isYewu: "",
      isRecharge: "",
      isEnabled: "",
      minTotalAward: "",
      active: {},
      address: {
        address1: "",
        address2: "",
        address3: "",
      },
      etw:false,
      amountList: [],
      edit_dialogVisible: false,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      setIsEnabledShow: false,
      password: "",
      withdrawPassword: "",
      lockDate: "",
      amount: "",
      isLock: false,
      allChildrenSum: {},
      childrenSum1: [],
      childrenSum2: [],
      childrenSum3: {},
      level: "1",
      amountOrder: "",
      platformMemo:"",
      totalRecharge: "",
      totalRechargeOrder: "",
      backendRecharge: "",
      teamAmount: "",
      childrenCount: "",
      totalRechargeTrx: "",
      totalRechargeBtc: "",
      totalRechargeEth: "",
      totalRechargeBnb: "",
      remainFeedDay: "",
      totalRechargeUsdc: "",
      totalRechargeDoge: "",
      totalRechargeTrx1: "",
      totalWithdrawTrx: "",
      totalWithdrawTrx1: "",
      amountTrxOrder: "",
      backendRechargeTrx: "",
      amountTRX: "",
      passwordTRX: "",
      teamLevelStr: "",
      totalInvestBuyAmountReal: "",
      totalInvestBuyAmountRealTrx: "",
      totalInvestBuyAmountRealBtc: "",
      totalInvestBuyAmountRealEth: "",
      totalInvestBuyAmountRealBnb: "",
      totalInvestBuyAmountRealUsdc: "",
      totalInvestBuyAmountRealDoge: "",

      totalEscapeBuyAmount: "",
      totalEscapeWinAmount: "",
      totalEscapeFailAmount: "",
      totalEscapePreAmount: "",
      totalEarn: "",
      totalTeamEarn: "",
      totalInvestBuyAmount: "",

      totalEscapeReturnAmount: "",

      setIsYewuPassword: "",
      setIsYewuShow: false,
      setIsEnabledPassword: "",
      activeIsEnabled:false,
      isWith2:'',
      memo:'',
      isWith:'',
      isValidRecharge:false,
      teamLevelAmount:''
    };
  },
  mounted() {
    this.getDate();
  },
  methods: {
    // 排序
    selectOrder(name, type) {
      this.amountOrder = "";
      this.totalRechargeOrder = "";
      this.backendRecharge = "";
      this.teamAmount = "";
      this.totalRecharge = "";
      this.childrenCount = "";
      this.totalRechargeTrx = "";
      this.totalWithdrawTrx = "";
      this.totalRechargeTrx1 = "";
      this.totalWithdrawTrx1 = "";
      this.amountTrxOrder = "";
      this.backendRechargeTrx = "";
      this.teamLevelStr = "";
      this.totalInvestBuyAmountReal = "";
      this.totalInvestBuyAmountRealTrx = "";
      this.remainFeedDay = "";

      this.totalInvestBuyAmountRealBtc = "";
      this.totalInvestBuyAmountRealEth = "";
      this.totalInvestBuyAmountRealBnb = "";
      this.totalInvestBuyAmountRealUsdc = "";
      this.totalInvestBuyAmountRealDoge = "";
      this.totalEarn = "";

      this.totalEscapeBuyAmount = "";
      this.totalEscapeWinAmount = "";
      this.totalEscapeFailAmount = "";
      this.totalEscapePreAmount = "";
      this.totalEscapeReturnAmount = "";
      this.totalTeamEarn = "";

      this.totalRechargeBtc = "";
      this.totalRechargeEth = "";
      this.totalRechargeBnb = "";
      this.totalRechargeUsdc = "";
      this.totalRechargeDoge = "";

      this.totalInvestBuyAmount = "";
      if (name == "余额") {
        this.amountOrder = type;
      }
      if (name == "实时投资金额") {
        this.totalInvestBuyAmountReal = type;
      }
      if (name == "团队等级") {
        this.teamLevelStr = type;
      }
      if (name == "累计投资金额") {
        this.totalInvestBuyAmount = type;
      }
      if (name == "剩余") {
        this.remainFeedDay = type;
      }
      if (name == "投资可出售TRX") {
        this.totalInvestBuyAmountRealTrx = type;
      }

      if (name == "投资可出售BTC") {
        this.totalInvestBuyAmountRealBtc = type;
      }
      if (name == "投资可出售ETH") {
        this.totalInvestBuyAmountRealEth = type;
      }
      if (name == "投资可出售BNB") {
        this.totalInvestBuyAmountRealBnb = type;
      }
      if (name == "投资可出售USDC") {
        this.totalInvestBuyAmountRealUsdc = type;
      }
      if (name == "投资可出售DOGE") {
        this.totalInvestBuyAmountRealDoge = type;
      }
      if (name == "累计收入USDT") {
        this.totalEarn = type;
      }
      if (name == "团队累计收入") {
        this.totalTeamEarn = type;
      }

      if (name == "投入金额") {
        this.totalEscapeBuyAmount = type;
      }
      if (name == "躲避金额") {
        this.totalEscapeWinAmount = type;
      }
      if (name == "划分金额") {
        this.totalEscapeFailAmount = type;
      }
       if (name == "奖励金额") {
        this.totalEscapePreAmount = type;
      }
      if (name == "退还金额") {
        this.totalEscapeReturnAmount = type;
      }

      if (name == "TRX余额") {
        this.amountTrxOrder = type;
      }
      if (name == "累计充值") {
        this.totalRecharge = type;
      }
      if (name == "累计充值TRX") {
        this.totalRechargeTrx = type;
      }

      if (name == "累计充值BTC") {
        this.totalRechargeBtc = type;
      }
      if (name == "累计充值ETH") {
        this.totalRechargeEth = type;
      }
      if (name == "累计充值BNB") {
        this.totalRechargeBnb = type;
      }
      if (name == "累计充值USDC") {
        this.totalRechargeUsdc = type;
      }
      if (name == "累计充值DOGE") {
        this.totalRechargeDoge = type;
      }

      if (name == "累计充值TRX1") {
        this.totalRechargeTrx1 = type;
        this.childrenSum();
        return;
      }
      if (name == "累计提现TRX") {
        this.totalWithdrawTrx = type;
      }
      if (name == "累计提现TRX1") {
        this.totalWithdrawTrx1 = type;
        this.childrenSum();
        return;
      }
      if (name == "累计提现") {
        this.totalRechargeOrder = type;
      }
      if (name == "累计后台充值") {
        this.backendRecharge = type;
      }
      if (name == "累计后台充值TRX") {
        this.backendRechargeTrx = type;
      }
      if (name == "团队余额") {
        this.teamAmount = type;
      }
      if (name == "下级总数") {
        this.childrenCount = type;
      }
      console.log("amountOrder", this.amountOrder);
      this.pageNum = 1;
      this.getList();
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    getDate() {
      this.getList();
    },
    toTree(row) {
      //   this.$router.push({
      //    path:'/tree',
      //    query:{
      // 	    uid:row.uid
      //     }
      //  })
      console.log(window.location.origin);
      window.open(
        `${window.location.origin}/gw/admin/memberTree.html?uid=${row.uid}`,
        "_blank"
      );
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        uid: this.uid,
        ip: this.ip,
        yifangUsername: this.yifangUsername,
        startDate: this.dataTime[0],
        endDate: this.dataTime[1],
        username: this.username,
        vipStr: this.vipStr,
        parentUid: this.parentUid,
        ipAddress: this.ipAddress,
        minChildCount: this.minChildCount,
        isYewu: this.isYewu,
        isRecharge: this.isRecharge,
        isEnabled: this.isEnabled,
        minTotalAward: this.minTotalAward,
        amountOrder: this.amountOrder,
        totalRecharge: this.totalRecharge,
        totalWithdraw: this.totalRechargeOrder,
        backendRecharge: this.backendRecharge,
        teamAmount: this.teamAmount,
        totalRechargeTrx: this.totalRechargeTrx,
        totalWithdrawTrx: this.totalWithdrawTrx,
        childrenCount: this.childrenCount,
        amountTrxOrder: this.amountTrxOrder,
        backendRechargeTrx: this.backendRechargeTrx,
        teamLevelStr: this.teamLevelStr,
        totalInvestBuyAmountReal: this.totalInvestBuyAmountReal,
        totalInvestBuyAmountRealTrx: this.totalInvestBuyAmountRealTrx,
        remainFeedDay: this.remainFeedDay,

        totalInvestBuyAmountRealBtc: this.totalInvestBuyAmountRealBtc,
        totalInvestBuyAmountRealEth: this.totalInvestBuyAmountRealEth,
        totalInvestBuyAmountRealBnb: this.totalInvestBuyAmountRealBnb,
        totalInvestBuyAmountRealUsdc: this.totalInvestBuyAmountRealUsdc,
        totalInvestBuyAmountRealDoge: this.totalInvestBuyAmountRealDoge,
        totalRechargeBtc: this.totalRechargeBtc,
        totalRechargeEth: this.totalRechargeEth,
        totalRechargeBnb: this.totalRechargeBnb,
        totalRechargeUsdc: this.totalRechargeUsdc,
        totalRechargeDoge: this.totalRechargeDoge,
        totalEscapeBuyAmount: this.totalEscapeBuyAmount,
        totalEscapeWinAmount: this.totalEscapeWinAmount,
        totalEscapeFailAmount: this.totalEscapeFailAmount,
        totalEscapePreAmount: this.totalEscapePreAmount,
        totalEscapeReturnAmount: this.totalEscapeReturnAmount,
        totalEarn: this.totalEarn,
        totalTeamEarn: this.totalTeamEarn,
        etw:this.etw?1:null,
        isLock: this.isLock,
        platformMemo: this.platformMemo,
        isWith2: this.isWith,
        memo: this.memo,
        totalInvestBuyAmount: this.totalInvestBuyAmount
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .memberList(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    happenTimeFun(num) {
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
    //编辑
    getSetIsEnabled(row) {
      this.active = row;
      this.active.etw =  this.active.etw == 1?true:false;
      this.activeIsEnabled = this.active.isEnabled
      this.password = row.password
      this.withdrawPassword = row.withdrawPassword
      this.isWith2 = row.isWith2
      this.edit_dialogVisible = true;
      if (row.lockDate) {
        this.lockDate = this.happenTimeFun(row.lockDate);
      } else {
        this.lockDate = "";
      }

      var params = {
        memberId: this.active.id,
      };
      this.$api.operate
        .viewSafeAddress(params)
        .then((res) => {
          this.address.address1 = res[0];
          this.address.address2 = res[1];
          this.address.address3 = res[2];
          console.log(this.address);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新账号状态
    setIsEnabled() {
      var params = {
        memberId: this.active.id,
        isEnabled: this.activeIsEnabled,
        password: this.setIsEnabledPassword,
      };
      this.$api.operate
        .setIsEnabled(params)
        .then((res) => {
          this.$message.success(res);
          this.active.isEnabled = this.activeIsEnabled
          this.getList();
          this.setIsEnabledShow = false
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
          
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeIsEnabled(){
      this.setIsEnabledPassword = ''
      this.activeIsEnabled = this.active.isEnabled
    },
    // 更新是否是业务员
    setIsYewu() {
      if (this.active.isYewu) {
        this.getSetIsYewu();
      } else {
        this.setIsYewuShow = true;
      }
    },
    // 更新是否是业务员
    setIsWith() {
      var params = {
          memberId: this.active.id,
          isWith2: this.isWith2
        }
      this.$api.operate 
        .setIsWith(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
        })
        .catch((err) => {
          this.isWith2 = this.active.isWith2
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSetIsYewu() {
      var params = {};
      if (this.active.isYewu) {
        params = {
          memberId: this.active.id,
          isYewu: this.active.isYewu
          
        };
      } else {
        params = {
          memberId: this.active.id,
          isYewu: this.active.isYewu,
          password: this.setIsYewuPassword,
        };
      }
      this.$api.operate
        .setIsYewu(params)
        .then((res) => {
          this.$message.success(res);
          this.setIsYewuShow = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新是否锁定VIP
    updateIsLockVip() {
      var params = {
        memberId: this.active.id,
        isLockVip: this.active.isLockVip,
      };
      this.$api.operate
        .updateIsLockVip(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateEtw() {
      var params = {
        memberId: this.active.id,
        etw: this.active.etw?1:0,
      };
      this.$api.operate
        .updateEtw(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateMemo() {
      var params = {
        memberId: this.active.id,
        memo: this.active.memo,
      };
      this.$api.operate
        .updateMemo(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateTeamLevelLock() {
      var params = {
        memberId: this.active.id,
        amount: this.active.totalInvestBuyAmountRealLock,
      };
      this.$api.operate
        .updateTeamLevelLock(params)
        .then((res) => {
          this.$message.success('更新成功');
          this.active.teamLevelStr = res
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新用户会员等级
    updateVipLevel() {
      var params = {
        memberId: this.active.id,
        vipLevel: this.active.vipLevel,
      };
      this.$api.operate
        .updateVipLevel(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新用户登录密码
    updatePassword() {
      var params = {
        memberId: this.active.id,
        password: this.password,
      };
      this.$api.operate
        .updatePassword(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 更新用户提现密码
    updateWithdrawPassword() {
      var params = {
        memberId: this.active.id,
        withdrawPassword: this.withdrawPassword,
      };
      this.$api.operate
        .updateWithdrawPassword(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateLockDate() {
      var params = {
        memberId: this.active.id,
        lockDate: this.lockDate,
      };
      this.$api.operate
        .updateLockDate(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 免邮箱验证提现地址
    updateSafeAddress() {
      let params = {
        memberId: this.active.id,
        ...this.address,
      };
      this.$api.operate
        .updateSafeAddress(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getChong(row) {
      this.active = row;
      this.dialogVisible = true;
      this.password = "";
      this.amount = "";
      this.amountTRX = "";
      this.passwordTRX = "";
    },
    // 手动充值
    chong() {
      var params = {
        memberId: this.active.id,
        amount: this.amount,
        password: this.password,
        isValidRecharge:this.isValidRecharge
      };
      this.$api.operate
        .chong(params)
        .then((res) => {
          this.$message.success(res);
          this.dialogVisible = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 手动充值
    chongTrx() {
      var params = {
        memberId: this.active.id,
        amount: this.amountTRX,
        password: this.passwordTRX,
      };
      this.$api.operate
        .chongTrx(params)
        .then((res) => {
          this.$message.success(res);
          this.dialogVisible = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getZiJin(row) {
      this.active = row;
      this.getChonList();
    },
    getChonList() {
      var params = {
        memberId: this.active.id,
        pageNumber: this.pageNum1,
        pageSize: this.pageSize1,
      };
      this.$api.operate
        .amountList(params)
        .then((res) => {
          this.amountList = res.records;
          this.dialogVisible1 = true;
          this.total1 = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getChildrenSumList() {
      this.loading1 = true;
      //
      this.$api.operate
        .children({
          memberId: this.active.id,
          level: this.level,
          totalRechargeTrx: this.totalRechargeTrx1,
          totalWithdrawTrx: this.totalWithdrawTrx1,
          pageNumber: this.pageNum2,
          pageSize: this.pageSize2,
        })
        .then((res) => {
          // this.childrenSum2 = res
          this.childrenSum2 = res.records;
          this.total2 = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading1 = false;
        });
    },
    getChildrenSum(row) {
      this.active = row;
      this.pageNum2 = 1;
      this.dialogVisible2 = true;
      this.totalRechargeTrx1 = "";
      this.totalWithdrawTrx1 = "";
      this.$api.operate
        .allChildrenSum({
          memberId: this.active.id,
        })
        .then((res) => {
          if (res) {
            this.allChildrenSum = res;
          }
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
      this.childrenSum();
      this.getChildrenSumList();
    },
    childrenSum() {
      this.$api.operate
        .childrenSum({
          memberId: this.active.id,
          level: this.level,
        })
        .then((res) => {
          if (res) {
            this.childrenSum3 = res;
          }
          // this.childrenSum3 = res.records;
          // this.total2 = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClick() {
      console.log(this.level);
      this.pageNum2 = 1;
      this.childrenSum();
      this.getChildrenSumList();
    },
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 10px;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;

      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
